import { INITIALIZE_AUTH } from '../actions/ActionTypes';
const initialState = {};
export const auth = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_AUTH:
      return {
        user: action.user,
        enabledGates: action.enabledGates
      };
    default:
      return state;
  }
};